import * as React from "react";

const BoxContext = React.createContext({
    boxId: null as number | null,
    boxData: {} as any,
    isBoxDataLoaded: false,
    loadBox: (id: number) => {}
});

export default BoxContext;